import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'multiMenuFilter' })
export class MultiMenuFilter implements PipeTransform {
  transform(filterOptions: Array<string>, searchText: string): Array<string> {
    if (!filterOptions || !searchText) return filterOptions;
    return filterOptions.filter((val: string) => val.toLowerCase().includes(searchText.toLowerCase()));
  }
}
